import { updatePositionUseCase } from '@src/main/modules/parameters/application/update/update-position.usecase';
import { CreateUpdatePositionRequest } from '@src/main/modules/parameters/infrastructure/dto/createUpdatePositionRequest';
import { createPositionHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/PositionHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdatePosition = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createPositionHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: CreateUpdatePositionRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await updatePositionUseCase(id, data, tokenProvider);
    },
  });
};
